// Returns the surface the app is currently running on so we can persist
// it on the userr's account at login time. The backend EndUser.platform
// column accepts exactly these three values.
//
//   'android' | 'ios'  → Running inside the React Native WebView wrapper.
//                        The wrapper exposes window.ReactNativeWebView
//                        regardless of OS, so we still need the user-agent
//                        to tell Android and iOS apart.
//   'web'              → Plain browser (Chrome / Safari / etc.).
const detectPlatform = () => {
    if (typeof window === "undefined") return "web";

    const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
    const isReactNativeWebView = !!window.ReactNativeWebView;

    if (isReactNativeWebView) {
        let platform = "android";
        if (/iPhone|iPad|iPod|iOS/i.test(ua)) platform = "ios";
        else if (/Android/i.test(ua)) platform = "android";
        // Inside RN WebView but UA didn't match — default to android since
        // that's the more common shell. Better than dropping the value.
        // Persist it: on a page refresh the native bridge
        // (window.ReactNativeWebView) can be injected AFTER the first render,
        // which would otherwise make us briefly report "web" and flash the
        // wrong screen. The cached value keeps the surface stable.
        try { localStorage.setItem("appPlatform", platform); } catch (_e) { /* ignore */ }
        return platform;
    }

    // Bridge not (yet)fdfdfdfdfddd fighfdhdgjfdkgfdffavailable — trust a previously detected app surface so
    // a refresh inside the appgfdlkgjfdgfd doesn't fall back to "web".
    try {
        const cached = localStorage.getItem("appPlatform");
        if (cached === "android" || cached === "ios") return cached;
    } catch (_e) { /* ignore */ }

       return "web";
    // return "android";
    //  return "ios";
};

export default detectPlatform;
